import React from "react";
import type { UseFormRegister, FieldErrors } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import type { BusinessProfileFormData } from "@/types/business-profile";

interface ContactInfoSectionProps {
  register: UseFormRegister<BusinessProfileFormData>;
  errors: FieldErrors<BusinessProfileFormData>;
  isSubmitting: boolean;
  loading: boolean;
}

export const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  register,
  errors,
  isSubmitting,
  loading,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-foreground">
        Contact Information
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="email">Business Email <span className="text-destructive">*</span></Label>
          <Input
            id="email"
            type="email"
            placeholder="contact@company.com"
            {...register("contact_info.email")}
            error={errors.contact_info?.email?.message}
            disabled={isSubmitting || loading}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="phone">Phone</Label>
          <Input
            id="phone"
            placeholder="+1 (555) 123-4567"
            {...register("contact_info.phone")}
            error={errors.contact_info?.phone?.message}
            disabled={isSubmitting || loading}
          />
        </div>
      </div>
    </div>
  );
};